import React from "react";
import { Modal, Divider, Flex, Button, Form, Input, message, Radio, Alert, Upload } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";

const validateID = (rule, value) => {
    const idRegex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
    if (!idRegex.test(value)) {
        return Promise.reject('请输入有效的身份证号码');
    }
    return Promise.resolve();
};


const Regist = () => {
    const [form] = Form.useForm();
    const [idImages, setIdImages] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const type = Form.useWatch('type', form);

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );

    React.useEffect(() => {
        initForm();
    }, []);

    const getDetail = async () => {
        let response = await fetch("/api/account/detail");
        let result = await response.json();

        if (result && result.success) {
            return result.data;
        }
    };

    const initForm = async () => {
        const values = await getDetail();
        if(typeof values === 'object') {
            setIdImages({
                idUrl: values.idUrl,
                idUrl2: values.idUrl2,
            });
            form.setFieldsValue(values);
        }
    }

    const beforeUpload = async (file) => {
        console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
          message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    const onRegist = async () => {
        try {
            const values = await form.validateFields();
            console.log("Success:", values);

            let response = await fetch("/api/login/regist2", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            let result = await response.json();

            if (result && result.success) {
                message.success("注册成功！");
                setTimeout(() => {
                    window.location.href = "/index";
                }, 1000);
            } else {
                message.error(result.data);
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo);
        }
    };

    const handleChange = (fieldName, {file}) => {
        // console.log(fieldName, file);

        if (file && file.status === 'done') {
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            setIdImages({
                ...idImages,
                [fieldName]: imgUrl,
            });
            form.setFieldsValue({ [fieldName]: imgUrl });
            setLoading(false);
        }else{
            if(loading === false) setLoading(true);
        }
    };

  return (
    <Form form={form} style={{ maxWidth: "600px", margin: "0 auto" }}>
        <h1>注册为家服务</h1>
        {
            form.getFieldValue('remark') && (
                <Alert message={form.getFieldValue('remark')} type="warning" />
            )
        }
        <Form.Item
            label="账户类型"
            name="type"
            tooltip="个人仅可创建一个店铺；公司可创建多店铺，并支持连锁。"
            rules={[{ required: true, message: "请选择账户类型" }]}
        >
            <Radio.Group>
                <Radio value={1}>个人</Radio>
                <Radio value={3}>个体户</Radio>
                <Radio value={2}>公司</Radio>
            </Radio.Group>
        </Form.Item>

        <Form.Item label="身份证">
            <Flex gap={10} justify="left" style={{flexDirection: 'column'}}>
                <Form.Item
                    label="身份证人像面"
                    name="idUrl"
                    rules={[{ required: true, message: '' }]}
                >
                    <Upload
                        beforeUpload={beforeUpload}
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        action={`/api/upload/image`}
                        onChange={(file) => handleChange('idUrl', file)}
                    >
                        {idImages.idUrl ? <img src={idImages.idUrl} style={{ width: '100%', height: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item
                    label="身份证反面"
                    name="idUrl2"
                    rules={[{ required: true, message: '' }]}
                >
                    <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        action="/api/upload/image"
                        // beforeUpload={beforeUpload}
                        onChange={(file) => handleChange('idUrl2', file)}
                    >
                        {idImages.idUrl2 ? <img src={idImages.idUrl2} style={{ width: '100%', height: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>
            </Flex>
        </Form.Item>

        <Form.Item
            label="姓名（公司类型请上传法人身份证）"
            name="realname"
            rules={[{ required: true, message: "请输入姓名" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item
            label="身份证号码"
            name="idNo"
            rules={[
                { required: true, message: "请输入身份证号码" },
                // { validator: validateID },
            ]}
        >
            <Input />
        </Form.Item>

        {
            (type === 2 || type === 3) &&  <><Form.Item
                label="公司营业执照"
                name="companyIdUrl"
                rules={[{ required: true, message: '' }]}
            >
                <Upload
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    action="/api/upload/image"
                    // beforeUpload={beforeUpload}
                    onChange={(file) => handleChange('companyIdUrl', file)}
                >
                    {idImages.companyIdUrl ? <img src={idImages.companyIdUrl} style={{ width: '100%' }} /> : uploadButton}
                </Upload>
            </Form.Item>

            <Form.Item
                label="公司名称"
                name="companyName"
                rules={[{ required: true, message: "请输入公司名称" }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="社会信用代码"
                name="companyId"
                rules={[{ required: true, message: "请输入社会信用代码" }]}
            >
                <Input />
            </Form.Item></>
        }

        <Divider />
        <Flex gap={20} justify="center">
            <Button type="primary" onClick={onRegist}>
                提交
            </Button>
        </Flex>
    </Form>
  );
};

export default Regist;
